import { FormControl, Switch } from '@mui/joy';

import { FormLabel } from 'core/elements';
import { LabelPosition } from 'core/enums';

import { DisabledTooltipWrapper } from './DisabledTooltipWrapper';
import { IProps } from './SwitchInput';

export const SwitchInputView = ({
  checked = false,
  wrapperSx,
  labelPosition = LabelPosition.START,
  disabledTooltip,
  labelSx,
  ...rest
}: IProps) => {
  const labelContent = (
    <FormLabel
      required={rest?.required}
      sx={{
        marginBottom: 0,
        cursor: !rest?.disabled ? 'pointer' : 'default',
        ...labelSx,
      }}
    >
      {rest?.label}
    </FormLabel>
  );

  return (
    <DisabledTooltipWrapper disabled={rest?.disabled} disabledTooltip={disabledTooltip}>
      <FormControl sx={{ flexDirection: 'row', alignItems: 'center', gap: 1, ...wrapperSx }}>
        {rest?.label && labelPosition === LabelPosition.START && labelContent}

        <Switch component="div" checked={checked} {...rest} />

        {rest?.label && labelPosition === LabelPosition.END && labelContent}
      </FormControl>
    </DisabledTooltipWrapper>
  );
};
